import { Application, Feature, Functionality } from '@frontend/functionality/types';
import { Route } from 'react-router-dom';

import { ApplicationBundleUsageLayout } from '../../components/application-bundle-usage-layout/application-bundle-usage-layout.component';
import { checkFeatureRoute, checkLicenseRoutes } from '../utils';
import { AwaitingDropOff } from './awaiting-drop-off/awaiting-drop-off.component';
import { AwaitingPickUp } from './awaiting-pick-up/awaiting-pick-up.component';
import Collis from './collis/collis.component';
import PuDoDashboard from './dashboard/dashboard.component';
import MyPudoHome from './my_pudo/my-pudo-home/my-pudo-home.component';
import { Transactions } from './transactions/transactions.component';
import { TransactionsCollis } from './transactions_collis/transactions_collis.component';

export function ApplicationsPudoRoutes(functionalities: Functionality[] | null) {
    const routeLicenseCheckResult = functionalities !== null ? checkLicenseRoutes(functionalities, Application.PUDO) : null;

    if (routeLicenseCheckResult && !routeLicenseCheckResult.appEnabled) {
        return null;
    }

    return (
        <Route
            path='pudo'
            element={<ApplicationBundleUsageLayout application={Application.PUDO} />}>
            <Route
                path='my_pudo'
                element={<MyPudoHome />}
            />
            {checkFeatureRoute(Feature.DASHBOARD, routeLicenseCheckResult) && (
                <Route
                    path='dashboard'
                    element={<PuDoDashboard />}
                />
            )}
            {checkFeatureRoute(Feature.INBOUND_TRANSACTION, routeLicenseCheckResult) && (
                <Route
                    path='awaiting_pick_up'
                    element={<AwaitingPickUp />}
                />
            )}
            {checkFeatureRoute(Feature.OUTBOUND_TRANSACTION, routeLicenseCheckResult) && (
                <Route
                    path='awaiting_drop_off'
                    element={<AwaitingDropOff />}
                />
            )}
            {checkFeatureRoute(Feature.TRANSACTIONS, routeLicenseCheckResult) && (
                <Route
                    path='transactions'
                    element={<Transactions />}
                />
            )}
            {checkFeatureRoute(Feature.TRANSACTIONS_COLLIS, routeLicenseCheckResult) && (
                <Route
                    path='transactions_collis'
                    element={<TransactionsCollis />}
                />
            )}
            {checkFeatureRoute(Feature.COLLIS, routeLicenseCheckResult) && (
                <Route
                    path='collis'
                    element={<Collis />}
                />
            )}
        </Route>
    );
}
